import { ReactNode } from 'react';

export type PillToggleVariant = 'critical' | 'warning' | 'success' | 'neutral';

export const SIZE_L = 'L';
export const SIZE_S = 'S';

export type PillToggleSize = typeof SIZE_L | typeof SIZE_S;

export interface PillToggleProps {
  variant: PillToggleVariant;
  label: string;
  size?: PillToggleSize;
  disabled?: boolean;
  /** Optional badge / dot rendered after the label, e.g. a "needs review" indicator. */
  indicator?: ReactNode;
  /** Stretches the pill to fill its container — used by segmented tab-strip layouts. */
  fullWidth?: boolean;
  /** Typography utility for the label. Defaults to `'text-subtitle-m'`; pass e.g. `'text-subtitle-s'`. */
  textClassName?: string;
  className?: string;
}
